import script from "./PermissionChangeConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionChangeConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./PermissionChangeConfirmation.vue?vue&type=style&index=0&id=2c30119a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c30119a"]])

export default __exports__